import FileCopyIcon from '@mui/icons-material/FileCopy'
import {
  styled,
  OutlinedInput,
  Paper,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell as MuiTableCell,
  Button,
  Grid,
  IconButton,
  Box,
  Typography,
} from '@mui/material'
import PreviewDom from 'components/DocumentDetail/PreviewDom'
import FormInput from 'components/ui/FormInput'
import InputCheckbox from 'components/ui/FormInputCheckbox'
import { ERROR_TEXT } from 'config'
import { Highlight } from 'entities/Documents'
import { useCallback } from 'react'
import { useFormContext } from 'react-hook-form'

const TableCell = styled(MuiTableCell)({
  fontSize: '13px',
  padding: '.825em 1em',
})

const CHECKBOX_STATE_LABEL = {
  checked: 'チェックあり',
  unchecked: 'チェックなし',
} as const

interface Option {
  label: string
  value: string
}

interface Props {
  label: string
  formKey: string
  item: any
  srcs: string[]
  highlights: Highlight[]
  users: {
    user1?: string
    user2?: string
    user3?: string
  }
  isInvoiceOrOrderForm: boolean
  type: 'text' | 'select' | 'checkbox'
  options?: Option[]
}

function withLabel(options: Option[] | undefined, value: string) {
  return ''.concat(options?.find((o) => o.value === value)?.label || '', ':', value)
}

function VerifyItem({
  label,
  formKey,
  item,
  users,
  isInvoiceOrOrderForm,
  srcs,
  highlights,
  type,
  options,
}: Props) {
  const { setValue } = useFormContext()

  // set veriable value to empty
  const clear = useCallback(() => setValue(formKey, ''), [setValue, formKey])
  const isCheckBox = type === 'checkbox'
  const isConcurRequired = item.isConcurRequired

  const getInputValue = (key) => {
    if (!isInvoiceOrOrderForm) {
      return isCheckBox ? item?.[`${key}Data`]?.checked : item?.[`${key}Data`]?.text
    }
    return item?.[`${key}Data`]
  }

  const userDataRows = Object.entries(users).map(([key, name], idx) => {
    const value = getInputValue(key)
    const copy = () => setValue(formKey, value)
    return (
      <TableRow key={key}>
        <TableCell>{idx + 1}</TableCell>
        <TableCell>{name}</TableCell>
        <TableCell>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            {isCheckBox ? (
              <InputCheckbox
                disabled
                value={value}
                onChange={() => {
                  console.log('no')
                }}
                stateLabel={isCheckBox ? CHECKBOX_STATE_LABEL : undefined}
              />
            ) : (
              <OutlinedInput
                margin="dense"
                size="small"
                disabled
                value={type === 'select' ? withLabel(options, value) : value}
              />
            )}
            <IconButton aira-label="copy the value" size="small" onClick={copy}>
              <FileCopyIcon fontSize="small" />
            </IconButton>
          </Box>
        </TableCell>
      </TableRow>
    )
  })

  return (
    <Paper variant="outlined" sx={{ m: 3 }}>
      <Table sx={{ fontSize: '13px' }}>
        <TableHead sx={{ '& .MuiTableCell-head': { bgcolor: 'grey.100' }, whiteSpace: 'nowrap' }}>
          <TableRow>
            <TableCell colSpan={2}>
              {label}
              {isConcurRequired && (
                <Typography display="inline" color="error" style={{ marginLeft: '3px' }}>
                  *
                </Typography>
              )}
            </TableCell>
            <TableCell sx={{ width: '75%' }}>
              <PreviewDom srcs={srcs} highlights={highlights ? highlights : []} height={56} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell variant="head">#</TableCell>
            <TableCell variant="head">チェック担当</TableCell>
            <TableCell variant="head">入力値</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {userDataRows}
          <TableRow>
            <TableCell colSpan={2}>最終入力値</TableCell>
            <TableCell>
              <Grid container alignItems="center" spacing={2}>
                <Grid item xs={8}>
                  <FormInput
                    statelabel={isCheckBox ? CHECKBOX_STATE_LABEL : undefined}
                    name={formKey}
                    type={type}
                    placeholder="値なし"
                    options={type === 'select' ? options : undefined}
                    rules={{
                      required: { value: isConcurRequired, message: ERROR_TEXT.required },
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  {!isCheckBox && (
                    <Button
                      variant="outlined"
                      onClick={clear}
                      color="secondary"
                      disabled={isConcurRequired}
                    >
                      値なし
                    </Button>
                  )}
                </Grid>
              </Grid>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Paper>
  )
}

export default VerifyItem
